"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = facebookPixelSubscriber;
var _enums = _interopRequireDefault(require("../types/enums"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var whiteListedURLs = [/\/collect\/audience\/.*\/status/];
var isValidURL = function isValidURL(url) {
  return whiteListedURLs.some(function (pattern) {
    return url.match(pattern) !== null;
  });
};
function facebookPixelSubscriber(digitalDataEvent) {
  // eslint-disable-next-line global-require
  var ReactPixel = require('react-facebook-pixel');
  var _JSON$parse = JSON.parse(JSON.stringify(digitalDataEvent.data)),
    name = _JSON$parse.name,
    data = _JSON$parse.data,
    key = _JSON$parse.key;
  var actionType = digitalDataEvent.name;
  if (isValidURL(window.location.href) && key) {
    ReactPixel.init(key);
    if (actionType === _enums.default.USER_METADATA && name && data) {
      ReactPixel.track(name, data);
    }
    if (actionType === _enums.default.PAGE_VIEW) ReactPixel.pageView();
  }
}
module.exports = exports.default;
//# sourceMappingURL=FacebookPixelSubscriber.js.map